import { useEffect, useRef, useState } from 'react';

export const formatTime = (timer: number): string => {
    const getSeconds: string = `0${timer % 60}`.slice(-2);
    const minutes: any = `${Math.floor(timer / 60)}`;

    return `${minutes} : ${getSeconds}`;
};

export function blobToFile(blob: Blob, fileName: string): any {
    try {
        const fileObj = new File([blob], fileName, { type: blob.type?.split(';')[0] });

        return fileObj;
    } catch (e) {
        // If Constructor fails(ie11) add properties to blob
        const file = blob as any;

        file.lastModifiedDate = new Date();
        file.lastModified = new Date().getTime();
        file.name = fileName;
        return file;
    }
}

export const useTimer = (initialState = 0): any => {
    const [timer, setTimer] = useState(initialState);
    const countRef = useRef<any>(null);

    const handleStart = (): void => {
        countRef.current = setInterval(() => {
            setTimer((timer) => timer + 1);
        }, 1000);
    };

    const handlePause = (): void => {
        clearInterval(countRef.current);
    };

    const handleResume = (): void => {
        countRef.current = setInterval(() => {
            setTimer((timer) => timer + 1);
        }, 1000);
    };

    const handleReset = (): void => {
        clearInterval(countRef.current);
        setTimer(0);
    };

    return { timer, handleStart, handlePause, handleResume, handleReset };
};

export function useCountDown(countdown = 3): any {
    const [timer, setTimer] = useState<any>(null);
    const intervalRef = useRef<any>(null);

    function startCountDown(): void {
        setTimer(countdown);
        intervalRef.current = setInterval(() => {
            setTimer((t: number) => t - 1);
        }, 1000);
    }

    useEffect(() => {
        return (): void => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
            }
        };
    }, []);

    function cancelCountdown(): void {
        setTimer(null);
        clearInterval(intervalRef.current);
    }

    useEffect(() => {
        if (timer === 0) {
            setTimer(null);
            clearInterval(intervalRef.current);
            intervalRef.current = null;
        }
    }, [timer]);

    return { countDown: timer, startCountDown, cancelCountdown };
}
